import { render } from "./FooterLandingPage.vue?vue&type=template&id=3e20889e&scoped=true"
import script from "./FooterLandingPage.vue?vue&type=script&lang=js"
export * from "./FooterLandingPage.vue?vue&type=script&lang=js"

import "./FooterLandingPage.vue?vue&type=style&index=0&id=3e20889e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e20889e"]])

export default __exports__